// Shared by manifest.mjs (node) and the host loader (browser), so no imports.
export const CONTRIBUTIONS_FORMAT = 1;
